
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"aria-hidden":"true","viewBox":"0 0 45 45","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill":"#fff","d":"M22.423 29.851L9.293 16.706a.999.999 0 111.414-1.413l11.718 11.73 11.73-11.717a1 1 0 011.414 1.415l-13.146 13.13z"}})])
          )
        }
      }
    